

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Box,
  Button,
  CircularProgress,

} from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { DELETE_HOLIDAY, GET_ALL_HOLIDAY } from "app/redux/actions/holidays";
import styled from "styled-components";

function Holidays() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.user.user);
  const holidays = useSelector((state) => state.holidays)



  const [openDialog, setOpenDialog] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    if (loggedInUser?.token) {
      dispatch(GET_ALL_HOLIDAY({
        page: 1, limit: 10,
      }, loggedInUser.token));
    }
  }, [dispatch, loggedInUser]);




  const handleEdit = (recordId) => {
    navigate(`/holiday/${recordId}`);
  };

  const handleDelete = (id) => {
    setId(id);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    if (id) {
      dispatch(DELETE_HOLIDAY(id, loggedInUser.token));
      setOpenDialog(false);
    }
  };
  const HorizontalTable = styled.div`
    overflow-x: auto;
  
    @media (max-width: 600px) {
    width: 360%;
    overflow-x: auto;
    }
  `;
  return (
    <SimpleCard>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Breadcrumb
          routeSegments={[
            {
              name: 'All Holidays',
            },
          ]}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/holiday")}
        >
          Create Holiday
        </Button>

      </Box>

      <Box padding={2} sx={{ flexGrow: 1, overflow: 'auto', paddingBottom: '70px' }}>
        <HorizontalTable>

          <TableContainer component={Paper} style={{ marginTop: "16px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ pl: 4 }}>Title</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Public Holiday</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {holidays.getAllLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : !holidays.getAll || (holidays.getAll?.holidays || []).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No records found.
                    </TableCell>
                  </TableRow>
                ) : (
                  (holidays.getAll?.holidays || []).map((record) => (
                    <TableRow key={record.id}>
                      <TableCell sx={{ pl: 4 }}>
                        {record.title || "N/A"}
                      </TableCell>
                      <TableCell>
                        {record.description || "N/A"}
                      </TableCell>
                      <TableCell>
                        {record.startDate || "All"}
                      </TableCell>

                      <TableCell>{record.endDate || '-'}</TableCell>

                      <TableCell>
                        {record.isPublicHoliday === true ? 'Yes' : 'No'}
                      </TableCell>
                      <TableCell>

                        <IconButton
                          onClick={() => handleEdit(record.id)}
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => handleDelete(record.id)}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>


                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </HorizontalTable>
      </Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Announcement record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </SimpleCard>
  );
}

export default Holidays;
